module.exports = __webpack_public_path__ + "static/media/lightRain.ddac1670.ico";